import { CooperationTypeBy } from "@interfaces/index";
import ArrowLeftIcon from "assets/svg/arrow-left-2.svg";
import HomeIcon from "assets/svg/home-2.svg";
import MapPinIcon from "assets/svg/map-pin.svg";
import Link from "next/link";
import React, { FC } from "react";

import styles from "./styles.module.css";

interface Props {
  info: {
    JobTitle: string;
    OrganizationName: string;
    Salary: string;
    CooperationType: string;
    City: string;
    Neighbourhood: string;
    Remote: string;
    Status: string;
    Id: number;
  };
}

const JobsCard: FC<Props> = ({ info }) => {
  const getCooperationBadge = (cooperationType: string) => {
    switch (cooperationType) {
      case "تمام وقت": {
        return (
          <div className="rounded bg-[#4F9B0B3D] px-2 py-1 text-xs font-bold text-[#4F9B0B]">
            تمام وقت
          </div>
        );
      }
      case "پاره وقت": {
        return (
          <div className="rounded bg-[#FBCF3238] px-2 py-1 text-xs font-bold text-[#F0BC01]">
            پاره وقت
          </div>
        );
      }
      case "پروژه ای": {
        return (
          <div className="rounded bg-[#FCEAD7] px-2 py-1 text-xs font-bold text-[#EE8A1E]">
            پروژه ای
          </div>
        );
      }
    }
  };
  return (
    <Link href={`job/${info.Id}/${info.JobTitle.trim().replaceAll(" ", "-")}`}>
      <a className="relative">
        {info.Status === "0" ? (
          <img
            src="/images/closed.png"
            className="absolute left-4 top-4"
            alt="closed"
            loading="lazy"
          />
        ) : undefined}
        <div
          className={`rounded py-5 pr-8 pl-4 shadow-jobsShadow2 ${
            info.Status === "0" ? "blur-[2px]" : ""
          } ${styles.card}`}
        >
          {info.Status !== "0" ? (
            <div className={styles.gradiantBG} />
          ) : undefined}
          <h2 className="text-base text-black-550 md:text-lg">
            {info.JobTitle}
          </h2>
          <div className="mt-3 flex items-center gap-2">
            <div className="flex gap-2">
              {getCooperationBadge(info.CooperationType)}
              {info.Remote === "دورکاری" ? (
                <div className="rounded bg-[#0577AF42] px-2 py-1 text-xs font-bold text-[#0577AF]">
                  دورکاری
                </div>
              ) : (
                <div className="rounded bg-[#77268B40] px-2 py-1 text-xs font-bold text-[#77268B]">
                  حضوری
                </div>
              )}
            </div>
            <div className="flex gap-2 text-xs font-bold">
              <div className="text-black-550">حقوق :</div>
              <div className="text-blue-550">{info.Salary}</div>
            </div>
          </div>
          <div className="mt-3 flex gap-2 text-base text-black-550">
            <HomeIcon />
            {info.OrganizationName}
          </div>
          <div className="mt-3 flex justify-between">
            <div className="flex gap-2 text-sm text-gray-350">
              <MapPinIcon />
              {info.City} / {info.Neighbourhood}
            </div>
            <div className="flex text-base font-bold text-blue-550 underline">
              جزییات بیشتر
              <ArrowLeftIcon />
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default JobsCard;
